function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Rate");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.73
}, React.createElement("g", {
  id: "icon-config.-rate",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "Shape"
}, React.createElement("path", {
  d: "M17.4857143,6.65109244 L17.4857143,0.727272727 C17.4857143,0.325611091 17.1787095,0 16.8,0 C16.4212905,0 16.1142857,0.325611091 16.1142857,0.727272727 L16.1142857,6.65117436 C15.1242553,6.96443353 14.4,7.93819044 14.4,9.09090909 C14.4,10.2416612 15.1229181,11.2171827 16.1142857,11.5307257 L16.1142857,15.2727273 C16.1142857,15.6743889 16.4212905,16 16.8,16 C17.1787095,16 17.4857143,15.6743889 17.4857143,15.2727273 L17.4857143,11.5306438 C18.4757447,11.2173847 19.2,10.2436277 19.2,9.09090909 C19.2,7.94015702 18.4770819,6.96463553 17.4857143,6.65109244 L17.4857143,6.65109244 Z M10.2857143,1.19654698 L10.2857143,0.727272727 C10.2857143,0.325611091 9.97870954,0 9.6,0 C9.22129046,0 8.91428571,0.325611091 8.91428571,0.727272727 L8.91428571,1.19662891 C7.92425534,1.50988807 7.2,2.48364498 7.2,3.63636364 C7.2,4.78711571 7.92291809,5.7626372 8.91428571,6.07618029 L8.91428571,15.2727273 C8.91428571,15.6743889 9.22129046,16 9.6,16 C9.97870954,16 10.2857143,15.6743889 10.2857143,15.2727273 L10.2857143,6.07609836 C11.2757447,5.7628392 12,4.78908229 12,3.63636364 C12,2.48561156 11.2770819,1.51009007 10.2857143,1.19654698 Z M3.08571429,9.92381971 L3.08571429,0.727272727 C3.08571429,0.325611091 2.77870954,0 2.4,0 C2.02129046,0 1.71428571,0.325611091 1.71428571,0.727272727 L1.71428571,9.92390164 C0.724255337,10.2371608 0,11.2109177 0,12.3636364 C0,13.5143884 0.722918091,14.4899099 1.71428571,14.803453 L1.71428571,15.2727273 C1.71428571,15.6743889 2.02129046,16 2.4,16 C2.77870954,16 3.08571429,15.6743889 3.08571429,15.2727273 L3.08571429,14.8033711 C4.07574466,14.4901119 4.8,13.516355 4.8,12.3636364 C4.8,11.2128843 4.07708191,10.2373628 3.08571429,9.92381971 L3.08571429,9.92381971 Z"
})))));

var SvgConfigRate = function SvgConfigRate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfigRate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/config-rate.f6c8effa.svg";
export { ForwardRef as ReactComponent };